package com.findyourbuddies.website.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.textDecoration
import org.jetbrains.compose.web.dom.A

@Composable
fun StoreButton(
    store: Store,
    modifier: Modifier = Modifier,
) {
    A(
        href = store.url,
        attrs = {
            target(ATarget.Blank)
            style {
                textDecoration("none")
                color(Colors.White)
            }
        }
    ) {
        Image(
            src = store.imagePath,
            alt = store.altText,
            modifier = modifier
                .cursor(Cursor.Pointer)
                .height(65.px)
                .padding(10.px),
        )
    }
}

@Composable
fun StoreButtons() {
    Column(
        modifier = Modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Row(
            modifier = Modifier.flexWrap(FlexWrap.Wrap),
            horizontalArrangement = Arrangement.Center,
        ) {
            StoreButton(store = Store.APP_STORE)

            StoreButton(store = Store.GOOGLE_PLAY)
        }
    }
}

enum class Store(val imagePath: String, val url: String, val altText: String) {
    APP_STORE("/images/badges/app-store-badge.png", "https://apps.apple.com/", "Download on the App Store"),
    GOOGLE_PLAY("/images/badges/google-play-badge.png", "https://play.google.com/store", "Download on Google Play"),
}
